// extracted by mini-css-extract-plugin
export var chatHtmlText = "_t0-2";
export var chatLink = "_t0-0";
export var chatText = "_t0-1";